import React from "react";
import { useForm } from "react-hook-form";
import services from '@api/services';
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { saveTAToken, saveTAData } from '../../store/slices/authenticationSlice'

const TALogin = () => {

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        try {
            const payload = {
                email: data.email,
                password: data.password
            }
            const res = await services.globalService.loginTravelAgentService(payload)
            if (res.data.status === true) {
                console.log('working...')
                dispatch(saveTAToken(res.data.token))
                dispatch(saveTAData(res.data.data))
                setTimeout(()=>{
                    navigate("/ta-profile");
                }, 0)
            }

        }
        catch {
            alert('Invalid email or password.')
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <h2 className="pb-6"><span className="text-brand">RROOMS</span> login as Travel Agent</h2>
            <div className="form-group">
                <label className="label">Email Id</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email Id"
                    {...register("email", {
                        required: "Email is required",
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Enter a valid email",
                        },
                    })}
                />
                {errors.email && (
                    <small className="text-danger">{errors.email.message}</small>
                )}
            </div>

            <div className="form-group mt-2">
                <label className="label">Password</label>
                <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password"
                    {...register("password", {
                        required: "Password is required",
                    })}
                />
                {errors.password && (
                    <small className="text-danger">{errors.password.message}</small>
                )}
            </div>

            <div className="form-group mt-3">
                <button type="submit" className="btn btn-info btn-block">Login</button>
            </div>

        </form>
    );
};

export default TALogin;
